import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { PdfExportFacade } from '@mode/report-viewer/pdf-export/domain';

export const DowngradedReportViewerPdfExportApiModule = angular
  .module('downgraded-report-viewer-pdf-export-api', [])
  .service('PdfExportFacade', downgradeInjectable(PdfExportFacade)).name;
